module.exports = __webpack_public_path__ + "img/lifestyle_ana.e9cb357d.png";